import { useState } from "react";
import { toast } from "react-toastify";
import moment from "moment/moment";

const notify = (message) => {
  window.navigator?.vibrate?.(200);
  toast.error(message, {
    position: "bottom-center",
    autoClose: 3000,
    theme: "light",
    hideProgressBar: true,
  });
};

export const validateCodeOpen = (ticket, setIsCodeOpen) => {
  const openBarcode = () => {
    window.navigator?.vibrate?.(200);
    setIsCodeOpen(true);
  };

  if (ticket.isSentByNextEnergy) {
    // 넥스트에너지 발송인지
    if (!ticket?.usedDate) {
      // 미사용 티켓

      // ******* 취소 관련 ****************
      if (ticket?.cancelDate) {
        // 취소 완료 => 바코드, 취소신청 모두 disable
        notify("취소 완료된 상품입니다.");
        return;
      } else {
        if (ticket.cancelRequestDate) {
          // 취소중 => 바코드, 취소신청 모두 disable
          notify("취소중인 상품입니다.");
          return;
        }
      }

      // ******* 유효기간 관련 ****************
      if (!ticket?.isValidTicket) {
        // 유효기간 지난 티켓 => 바코드, 취소신청 모두 disable
        if (ticket.validDate === "유효기간 만료") {
          notify("유효기간이 지난 상품입니다.");
        } else if (ticket.validDate === "티켓 이용기간 X") {
          notify("아직 티켓 이용기간이 아닙니다.");
        }

        return;
      }

      openBarcode(); // 위의 조건들에 걸러지지 않을 때만 바코드 오픈
    }
  } else {
    // 외부 발송이면 바코드 열리면 안됨
    notify(
      "별도 발송된 모바일 이용권을 확인해주세요.(상품설명 내 발송방법 확인!)"
    );
  }
};

export const validateCancelRequestOpen = (ticket, goToTicketCancel) => {
  const isCancelPossibleTicket = () => {
    const deadline = moment(ticket.sendDate).add(7, "d").format("YYYY-MM-DD");

    if (moment(deadline).isAfter(moment().format("YYYY-MM-DD")) === true) {
      return true;
    } else {
      // 만약 오늘이 발송일+7 이 지났다면 => 취소신청 disable
      return false;
    }
  };

  if (!ticket?.usedDate) {
    // 미사용 티켓

    // *******  관련 ****************
    if (!ticket?.isRefundPossible) {
      // 취소 불가 상품
      notify("취소 불가 상품입니다.");
      return;
    } else {
      if (!isCancelPossibleTicket()) {
        // 환불 가능 상품이더라도 환불 가능 기간인지 확인
        notify("취소 가능 기간이 지난 상품입니다.");
        return;
      }
    }

    // ******* 취소 관련 ****************
    if (ticket?.cancelDate) {
      // 취소 완료
      notify("취소 완료된 상품입니다.");
      return;
    } else {
      if (ticket.cancelRequestDate) {
        // 취소중
        notify("취소중인 상품입니다.");
        return;
      }
    }

    // ******* 유효기간 관련 ****************
    if (!ticket?.isValidTicket && ticket.validDate === "유효기간 만료") {
      // 유효기간 지난 티켓

      notify("유효기간이 지난 상품입니다.");

      return;
    }

    // 모든 조건 만족한다면 취소 요청 페이지로 이동
    goToTicketCancel(ticket.pk);
  }
};
